import { Loading, SplitPanel } from '@components/atomic/atoms';
import UploadDocument from '@components/form/upload/uploadDocuments';
import { IcoClose } from '@icons';
import { getModalData } from '@lib/api';
// import { dateFormatter, formatToDecimals } from '@lib/helpers/formatting';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { Button, /*Col, Form,*/ Modal /*, Row*/ } from 'react-bootstrap';
import { ResumeChecklistProjectType } from './ResumeChecklistCellRenderer';
// import StopLightWithMessage from './StopLightWithMessage';
import SummaryPaymentModalInfo from './SummaryPaymentModalInfo';
// import SummaryPaymentModalInfo from './SummaryPaymentModalInfo';

interface SummaryPaymentModalProps {
	show: boolean;
	onHide: () => void;
	apiUrl: string;
	project: ResumeChecklistProjectType;
}

export type PaymentDataType = {
	id: string;
	payeeName?: string;
	payeeCode?: string;
	lastPayeeName?: string;
	paymentType?: string;
	paymentNumber?: string;
	proposalCode?: string;
	date?: string;
	currencyCode?: string;
	cro?: string;
	invoice?: {
		rpCode?: string;
		number?: string;
		taxableAmount?: number;
		totalAmount?: number;
	};
	checkliststatus?: {
		color: string;
	};
};

const SummaryPaymentModal: React.FC<SummaryPaymentModalProps> = ({ show, onHide, apiUrl, project }) => {
	const { data: modalData, isPending: isPendingModalData } = useQuery<{
		data: PaymentDataType;
	}>({
		queryKey: ['modalData', apiUrl],
		queryFn: () => getModalData(apiUrl),
		enabled: show,
	});
	const paymentData = modalData?.data;
	return (
		<Modal fullscreen show={show} onHide={onHide}>
			<Modal.Header
				style={{
					padding: '2rem',
					justifyContent: 'space-between',
				}}
			>
				<Modal.Title>
					<h2 style={{ fontSize: '28px', marginBottom: '0.5rem' }}>Controllo del pagamento {paymentData?.id}</h2>
					<h3
						style={{
							fontSize: '18px',
							fontWeight: 700,
						}}
					>
						PROGETTO: {project.name}
					</h3>
				</Modal.Title>
				<Button
					className="btn custom-ghost-button"
					onClick={onHide}
					style={{
						color: 'var(--np-primary-color)',
						display: 'flex',
						alignItems: 'center',
						gap: '0.75rem',
					}}
				>
					Chiudi
					<IcoClose
						style={{
							fill: 'var(--np-primary-color)',
						}}
					/>
				</Button>
			</Modal.Header>
			<Modal.Body
				style={{
					padding: '2rem',
					overflow: 'hidden',
				}}
			>
				{isPendingModalData ? (
					<Loading />
				) : show ? (
					<SplitPanel
						panels={[
							{
								key: 'info',
								title: 'Informazioni',
								content: <SummaryPaymentModalInfo paymentData={paymentData} />,
							},
							{
								key: 'documents',
								title: 'Documenti',
								content: (
									<div>
										<UploadDocument entity="payments" entityId={paymentData.id} title="Documenti correlati" />
									</div>
								),
							},
						]}
					/>
				) : null}
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={onHide} className="btn custom-outline-button custom-medium-button">
					Annulla
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default SummaryPaymentModal;
